// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixedLabel {
  min-width: 40% !important;
  max-width: 40% !important;
}

.fixedQuantity {
  min-width: 25px !important;
  max-width: 25px !important;
}

ion-modal.bottom-end {
  align-items: flex-end;
  --height: auto;
}
ion-modal.bottom-end .ion-page {
  position: relative;
  display: block;
  contain: content;
}

ion-grid {
  background-color: #f4f5f8;
  margin-bottom: 20px;
}

ion-col {
  background-color: #f4f5f8;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/quote-new/quote-new.page.scss"],"names":[],"mappings":"AAAA;EACQ,yBAAA;EACA,yBAAA;AACR;;AAEA;EACQ,0BAAA;EACA,0BAAA;AACR;;AAGE;EACE,qBAAA;EACA,cAAA;AAAJ;AACI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AACN;;AAIA;EACI,yBAAA;EACA,mBAAA;AADJ;;AAIA;EACE,yBAAA;EACA,kBAAA;AADF","sourcesContent":[".fixedLabel {\n        min-width: 40% !important;\n        max-width: 40% !important;\n    }\n\n.fixedQuantity {\n        min-width:25px !important;\n        max-width:25px !important;\n}\n\nion-modal {\n  &.bottom-end {\n    align-items: flex-end;\n    --height: auto;\n    .ion-page {\n      position: relative;\n      display: block;\n      contain: content;\n    }\n  }\n}\n\nion-grid { \n    background-color: #f4f5f8;\n    margin-bottom:20px\n}\n\nion-col {\n  background-color: #f4f5f8;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
